import { Box, Flex, HStack } from '@talos/kyoko';
import styled from 'styled-components';

export const MultiComboWrapper = styled(Box)`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .highcharts-area.zone-negative {
    fill: ${({ theme }) => theme.colors.red.default};
    fill-opacity: 0.1;
  }
  .highcharts-point.zone-negative {
    display: none;
  }
  .highcharts-graph.zone-negative {
    stroke: ${({ theme }) => theme.colors.red.default};
  }

  .highcharts-area.zone-positive {
    fill: ${({ theme }) => theme.colors.green.default};
    fill-opacity: 0.1;
  }
  .highcharts-point.zone-positive {
    display: none;
  }
  .highcharts-graph.zone-positive {
    stroke: ${({ theme }) => theme.colors.green.default};
  }

  .ag-row {
    .ag-cell.ag-cell-editable {
      background: ${({ theme }) => theme.colors.gray['030']};
      width: 100px !important; // force override to match UX, else this will grow to fill the cell which is not what we want
      height: 25px !important; // force override to match UX, else this will grow to fill the cell
      margin-top: ${({ theme }) => theme.spacing4}px;
      border-radius: ${({ theme }) => theme.borderRadiusDefault}px;

      &.ag-cell-larger {
        width: 170px !important;

        & > span {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

    .ag-cell.ag-cell-value.ag-cell-initiating > div {
      justify-content: flex-start !important;
    }

    .ag-cell.ag-cell-value.ag-cell-ratio-positive > span,
    .ag-cell.ag-cell-value.ag-cell-type-call > span {
      color: ${({ theme }) => theme.colorTextPositive};
    }

    .ag-cell.ag-cell-value.ag-cell-ratio-negative > span,
    .ag-cell.ag-cell-value.ag-cell-type-put > span {
      color: ${({ theme }) => theme.colorTextNegative};
    }
  }
`;

export const MultiLegOrderBookHeader = styled(HStack)``;
MultiLegOrderBookHeader.defaultProps = {
  h: 40,
  justifyContent: 'space-between',
  px: 'spacing12',
  flex: '0 0 auto',
  background: 'backgroundContent',
};

export const MultiLegOrderBookWrapper = styled(Flex)`
  transition: flex 200ms ease;
`;
MultiLegOrderBookWrapper.defaultProps = {
  flexDirection: 'column',
  h: '100%',
  flex: '0 0 100%',
  position: 'relative',
  overflow: 'hidden',
  background: 'backgroundBody',
  gap: '1px',
};
